import { UserSymbol } from '@d/auth/helper/auth'

export function isNewsTenant(): boolean {
  const user = inject(UserSymbol)
  const tenant = computed(() => user?.value?.profile.aud[user?.value.profile.aud.length - 2])
  const config = useRuntimeConfig()
  return config.public.news === tenant.value
}
